export default __webpack_public_path__ + "static/media/B0002.d110ef90.png";